import { makeStyles, Theme } from "@material-ui/core";
import {
  boldFont,
  customButtonStyle,
  mediumFont,
  getCurrentAccentColor,
  getCurrentAccentTextColor,
  lightGrey,
  darkGrey,
  getRelativeFontSize,
} from "../../../utils/styles";

const floatButtonStyles = makeStyles(
  (theme: Theme) => ({
    floatingBtn: {
      position: "fixed",
      bottom: "0px",
      left: "0px",
      right: "0px",
      padding: "10px",
      // backgroundColor: getCurrentBackgroundColor(),
    },
    btnStyle: {
      ...customButtonStyle,
      ...mediumFont,
      width: "100%",
      // boxShadow: "5px 6px 5px 0px #00000029",
      backgroundColor: getCurrentAccentColor(),
      color: getCurrentAccentTextColor(),
      "&:hover": {
        backgroundColor: getCurrentAccentColor(),
        color: getCurrentAccentTextColor(),
      },
      display: "flex",
      justifyContent: "space-between",
    },
    disabledBtn: {
      ...customButtonStyle,
      ...mediumFont,
      width: "100%",
      // boxShadow: "5px 6px 5px 0px #00000029",
      backgroundColor: lightGrey,
      color: darkGrey,
      "&:hover": {
        backgroundColor: lightGrey,
        color: darkGrey,
      },
      display: "flex",
      justifyContent: "space-between",
    },
    noOfItems: {
      ...mediumFont,
      opacity: "80%",
    },
    price: {
      ...mediumFont,
      opacity: "80%",
    },
    label: {
      ...boldFont,
      fontSize: getRelativeFontSize(6),
    },
    glydeGif: {
      width: "22px",
      height: "22px",
    },
    loading: {
      width: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    background: {
      background: "none ",
      border: `2px solid ${getCurrentAccentColor()}`,
      "&:hover": {
        background: "none",
      },
    },
  }),
  { index: 1 }
);

export default floatButtonStyles;
